export const reportsCustomOptions = [
	{
		label: "Custom",
		value: "custom"
	},
	{
		label: "Quarterly",
		value: "quarterly"
	},
	{
		label: "Yearly",
		value: "yearly"
	}
]
